module.exports = __webpack_public_path__ + "static/media/farm-map2-bg.3924e0c0.png";